import { Component, Input, OnInit } from '@angular/core';
import { ProjectModel } from '../../../../../hub_schema/hubTypes';
import { getCurrentFiscalYear } from '../../../../shared/helpers/get-current-fiscal-year';

const estimatedTncCostsFinanceMetricId: number = 1000;
const estimatedNonTncCostsFinanceMetricId: number = 1001;

@Component({
    selector: 'app-estimated-costs-panel',
    templateUrl: './estimated-costs-panel.component.html',
    styleUrl: './estimated-costs-panel.component.scss',
    standalone: false
})
export class EstimatedCostsPanelComponent implements OnInit {

    @Input()
    public project: ProjectModel;
    public fiscalYears: number[];

    public ngOnInit(): void {
        this.fiscalYears = this.getFiscalYears();
    }

    public getFiscalYears(): number[] {
        // start with first fiscal year in the financials

        const fiscalYears = this.project.projectFinancials?.map(pf => pf.year).sort();
        const years: number[] = [];
        let year = fiscalYears[0];

        if (!year) {
            year = getCurrentFiscalYear();
        }

        while (year <= 2030) {
            const yearExistsInFinancials = this.project.projectFinancials?.some(pf => pf.year === year);
            if (yearExistsInFinancials) {
                years.push(year);
            }
            year++;
        }
        return years;
    }

    public getEstimatedTncCosts(year: number): number {
        const financial = this.project.projectFinancials?.find(pf => pf.year === year && pf.financeMetricId === estimatedTncCostsFinanceMetricId);
        return financial ? financial.value : 0;
    }

    public getEstimatedNonTncCosts(year: number): number {
        const financial = this.project.projectFinancials?.find(pf => pf.year === year && pf.financeMetricId === estimatedNonTncCostsFinanceMetricId);
        return financial ? financial.value : 0;
    }

    public getUpdatedBy(year: number): string {
        const financial = this.project.projectFinancials?.find(pf => pf.year === year);
        return financial ? financial.modifiedBy?.fullName! : '';
    }

    public getUpdatedOn(year: number): Date {
        const financial = this.project.projectFinancials?.find(pf => pf.year === year);
        return financial!.modifiedOn!;
    }

    public getTotalEstimatedTncCosts(): number {
        let sum = 0;

        for (const year of this.fiscalYears) {
            sum += this.getEstimatedTncCosts(year);
        }

        return sum;
    }

    public getTotalEstimatedNonTncCosts(): number {
        let sum = 0;

        for (const year of this.fiscalYears) {
            sum += this.getEstimatedNonTncCosts(year);
        }

        return sum;
    }

}
